import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/index.vue'
import e1 from '@/pages/e1.vue'
import e2 from '@/pages/e2.vue'
import e3 from '@/pages/e3.vue'
import e4 from '@/pages/e4.vue'
import e5 from '@/pages/e5.vue'
import e6 from '@/pages/e6.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/index',
      name: 'Home',
      component: Home
    },
    {
      path: '/e1',
      name: 'e1',
      component: e1
    },
    {
      path: '/e2',
      name: 'e2',
      component: e2
    },
    {
      path: '/e3',
      name: 'e3',
      component: e3
    },
    {
      path: '/e4',
      name: 'e4',
      component: e4
    },
    {
      path: '/e5',
      name: 'e5',
      component: e5
    },
    {
      path: '/e6',
      name: 'e6',
      component: e6
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js